/* eslint-disable no-dupe-keys */
// @flow

const taskV2ActivityStyles = {
  messageThread: (theme) => ({
    transformOrigin: '50% 50%',
    transform: 'rotate(180deg)',
    backgroundColor: 'white',
    maxWidth: '100vw'
  }),
  
  messageLineCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    },
    backgroundColor: 'white'
  }),
  
  messageLineCtrCustomer: (theme) => ({
    alignItems: 'flex-end'
  }),
  
  messageLineCtrSupport: (theme) => ({
    alignItems: 'flex-start'
  }),
  
  messageCtr: (theme) => ({
    boxShadow: 'none',
    width: 'fit-content',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    transform: 'rotate(180deg)',
    [theme.breakpoints.down('xs')]: {
      maxWidth: `calc(100vw - ${theme.spacing(1)})`
    }
  }),
  
  messageContent: (theme) => ({
    fontSize: '1rem',
    whiteSpace: 'break-spaces'
  }),
  
  customerMsg: (theme) => ({
    backgroundColor: '#e0e0e0'
  }),
  
  supportMsg: (theme) => ({
    backgroundColor: theme.palette.primary.lighter
  }),
  
  msgCaption: (theme) => ({
    fontSize: '0.8rem',
    marginBottom: theme.spacing(2)
  }),
  
  logCtr: (theme) => ({
    boxShadow: 'none',
    transform: 'rotate(180deg)',
    backgroundColor: 'transparent',
    textAlign: 'center',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '& p': {
      fontSize: '0.95rem'
    }
  }),
  
  attachmentRowCtr: (theme) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'visible',
    transform: 'rotate(180deg)',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    '& > div > img': {
      display: 'block',
      width: 150,
      minWidth: 150,
      height: 150
    },
    '& .__react_modal_image__modal_container': {
      transform: 'rotate(180deg)',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '75vw',
      height: 50,
      [theme.breakpoints.down('sm')]: {
        transform: 'rotate(180deg)',
        position: '-webkit-sticky',
        position: 'sticky',
        zIndex: '9999',
        top: theme.layout.customProps.header.height,
        left: '50%',
        width: '75vw',
        height: 300
      }
    }
  }),
  
  attachmentImgZoomPaper: (theme) => ({
    backgroundColor: 'transparent',
    filter: 'drop-shadow( 2px 1px 2px rgba(0, 0, 0, .1))',
    '&.MuiPaper-elevation24': {
      boxShadow: 'none'
    }
  }),
  
  closeIcon: (theme) => ({
    color: 'white'
  }),
  
  zoomCloseBtn: (theme) => ({
    position: 'absolute',
    top: 0,
    right: 0
  }),
  
  attachmentImgZoom: (theme) => ({
    width: '100%',
    height: 'auto'
  }),
  
  attachment: (theme) => ({
    transform: 'rotate(180deg)',
    border: `2px solid ${theme.palette.primary.lighter}`,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
    height: 150,
    width: 'auto',
    cursor: 'pointer',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.shape.borderRadius / 2
    }
  }),
  
  newMsgIndicatorCtr: (theme) => ({
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.error.main}`,
    width: '100%',
    transform: 'rotate(180deg)',
    '&:focus': {
      outline: 'none'
    }
  }),
  
  newMsgIndicator: (theme) => ({
    margin: '0 auto',
    width: 'auto',
    padding: theme.spacing(1),
    textAlign: 'center',
    transform: `translate(0, -${theme.spacing(2.2)}) scale(1)`,
    backgroundColor: theme.palette.background.default,
    display: 'table',
    color: theme.palette.error.main
  }),
  
  messageCaptionCtr: (theme) => ({
    display: 'flex',
    transform: 'rotate(180deg)'
  }),
  
  deliveryIconCtr: (theme) => ({
    marginLeft: theme.spacing(0.5),
    position: 'relative',
    top: -3
  }),
  
  deliveryIconSending: (theme) => ({
    color: theme.palette.messageDeliveryStatuses.sending
  }),
  
  deliveryIconDelivered: (theme) => ({
    color: theme.palette.messageDeliveryStatuses.delivered
  }),
  
  deliveryIconFailed: (theme) => ({
    color: theme.palette.messageDeliveryStatuses.failed
  }),
  
  avatarCtr: (theme) => ({
    position: 'relative'
  }),
  
  iframeWrapperMobile: (theme) => ({
    [theme.breakpoints.down('sm')]: {
      maxWidth: `calc(100vw - ${theme.spacing(1)})`
    }
  })
};

export default taskV2ActivityStyles;
